// Centralized asset paths
export const LOGO_SRC = '/images/logo.png';
